module.exports = __webpack_public_path__ + "img/laoshi.b9c71603.png";